import { FetchResult, gql } from '@apollo/client';

import { ApplyForFiberWaitlistInput, ApplyForFiberWaitlistPayload } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

export type ApplyForFiberWaitlistResponse = FetchResult<{ applyForFiberWaitlist: ApplyForFiberWaitlistPayload }>;

export const APPLY_FOR_FIBER_WAITLIST = gql`
  mutation applyForFiberWaitlist($input: ApplyForFiberWaitlistInput!) {
    applyForFiberWaitlist(input: $input) {
      lead
    }
  }
`;

export default async function applyForFiberWaitlistAsync({
  input,
}: {
  input: ApplyForFiberWaitlistInput;
}): Promise<ApplyForFiberWaitlistResponse> {
  const result = await client.mutate({
    mutation: APPLY_FOR_FIBER_WAITLIST,
    variables: { input },
  });
  return result.data?.applyForFiberWaitlist;
}
